import { render, staticRenderFns } from "./tabs-pane.vue?vue&type=template&id=5188fb7d&scoped=true&"
import script from "./tabs-pane.vue?vue&type=script&lang=js&"
export * from "./tabs-pane.vue?vue&type=script&lang=js&"
import style0 from "./tabs-pane.vue?vue&type=style&index=0&id=5188fb7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188fb7d",
  null
  
)

export default component.exports